module.exports = __webpack_public_path__ + "static/img/daba.18e7533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/daba.png
// module id = 0rVC
// module chunks = 1